// ConfirmDeleteModal.jsx 🧨 Styled like Profile UI
import React from "react";
import { Modal } from "react-bootstrap";
import "./styles/ConfirmDeleteModal.css"; // ⬅️ NEW style file

export default function ConfirmDeleteModal({ show, onHide, onConfirm, deleting }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      dialogClassName="custom-mfa-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-exclamation-triangle-fill me-2 text-warning" />
          Confirm Deletion
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="delete-message">Are you sure you want to delete this IoC?</p>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn-profile" onClick={onHide} disabled={deleting}>
          Cancel
        </button>
        <button className="btn-profile btn-danger" onClick={onConfirm} disabled={deleting}>
          {deleting ? "Deleting..." : "Delete"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
